export default {
  "Finance": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Finanzen"])},
  "Fitness": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Fitness"])},
  "Recipes": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Rezepte"])},
  "ShoppingList": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Einkaufsliste"])},
  "Watchlist": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Watchlist"])},
  "Wishlist": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Wunschliste"])},
  "Default": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Dashboard"])},
  "Settings": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Einstellungen"])}
}